import type { TeamPlayerFinderRegistration } from '../types'
import { playerFinderPositionName } from './registrationLabel'

export interface PlayerFinderPositionOption {
  label: string
  value: string
}

/**
 * The Positions Needed choices: every position of the competition's sport, plus
 * any position the ad already asks for that is not among them, so a stored
 * choice is always shown by name rather than as a bare id. Server order is kept;
 * a position is never offered twice.
 */
export const playerFinderPositionOptions = (
  entry: TeamPlayerFinderRegistration
): PlayerFinderPositionOption[] => {
  const options: PlayerFinderPositionOption[] = []
  const seen = new Set<string>()

  for (const position of [...entry.available_positions, ...entry.positions]) {
    const value = String(position.id)
    if (seen.has(value)) {
      continue
    }
    seen.add(value)
    options.push({ label: playerFinderPositionName(position), value })
  }

  return options
}
